const hotelRoomsContainerEl = document.querySelector('.hotel-rooms-container');

if (hotelRoomsContainerEl) {
	const hotelRoomsItemEls = hotelRoomsContainerEl.querySelectorAll('.hotel-rooms-item');
	const seeMoreTriggerEls = hotelRoomsContainerEl.querySelectorAll('.js-see-more-room-detail');
	const collapsedHeight = 200;
	const observerEls = [];

	seeMoreTriggerEls.forEach((triggerEl) => {
		triggerEl.addEventListener('click', (event) => {
			event.preventDefault();
			event.stopPropagation();

			const target = event.currentTarget;
			const itemEl = triggerEl.closest('.hotel-rooms-item');
			const contentEl = itemEl.querySelector('.hotel-rooms-content');
			const collapsedItemEls = contentEl.querySelectorAll('.collapsed-item');

			if (target.getAttribute('data-text-expanded') === 'expanded') {
				itemEl.classList.add('sm:items-center');
				collapsedItemEls.forEach((cItemEl) => {
					cItemEl.classList.add('!hidden');
				});
				target.innerHTML = 'See more';
				target.setAttribute('data-text-expanded', '');
			} else {
				itemEl.classList.remove('sm:items-center');
				collapsedItemEls.forEach((cItemEl) => {
					cItemEl.classList.remove('!hidden');
				});
				target.innerHTML = 'See less';
				target.setAttribute('data-text-expanded', 'expanded');
			}
		});
	});

	const collapsedContent = (contentEl) => {
		const seeMoreTriggerEl = contentEl.nextElementSibling;
		if (!seeMoreTriggerEl || seeMoreTriggerEl.getAttribute('data-text-expanded') === 'expanded') {
			return;
		}

		const contentHeight = contentEl.getAttribute('data-content-height');
		const collapsedItemEls = contentEl.querySelectorAll('.collapsed-item');
		collapsedItemEls.forEach((cItemEl) => {
			cItemEl.classList.remove('collapsed-item', '!hidden');
		});

		if (contentHeight > collapsedHeight && collapsedHeight !== 0) {
			const contentChildEls = contentEl.querySelectorAll(':scope > *');
			contentChildEls.forEach((childEl) => {
				if (childEl.offsetTop > collapsedHeight) {
					childEl.classList.add('collapsed-item', '!hidden');
				}
				if (childEl.classList.contains('text-rte')) {
					const grandChildEls = childEl.querySelectorAll('ul li');
					grandChildEls.forEach((gChildEl) => {
						const gChildElOffsetTop = gChildEl.offsetTop + gChildEl.offsetHeight;
						if (gChildElOffsetTop > collapsedHeight) {
							gChildEl.classList.add('collapsed-item', '!hidden');
						}
					});
				}
			});
		} else if (contentHeight < collapsedHeight && collapsedHeight !== 0) {
			if (seeMoreTriggerEl) {
				seeMoreTriggerEl.remove();
			}
		}
	};

	hotelRoomsItemEls.forEach((item) => {
		const contentEl = item.querySelector('.hotel-rooms-content');
		contentEl.setAttribute('data-content-height', contentEl.scrollHeight);
		observerEls.push(contentEl.parentElement);
		collapsedContent(contentEl);
	});

	const resizeObserver = new ResizeObserver((entries) => {
		entries.forEach((entry) => {
			const cr = entry.contentRect;
			if (cr.height > 200 || cr.height < 170) {
				collapsedContent(entry.target.querySelector('.hotel-rooms-content'));
			}
		});
	});

	// start observing a DOM node
	observerEls.forEach((el) => {
		resizeObserver.observe(el);
	});
}
